import CodeIcon from '@mui/icons-material/Code';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import type React from 'react';
import type { ReadFileToolArguments } from 'services/types/ticket';

import MessageWrapper from './MessageWrapper';

interface Props {
  args: string;
}

const ReadFileToolComponent: React.FC<Props> = ({ args }) => {
  let parsedArgs: ReadFileToolArguments;

  try {
    parsedArgs = JSON.parse(args) as ReadFileToolArguments;
  } catch (_error) {
    return (
      <MessageWrapper caption="Herramienta de Lectura" align="left">
        <Typography color="error">Error al parsear argumentos: {args}</Typography>
      </MessageWrapper>
    );
  }

  return (
    <MessageWrapper caption="Leer archivo" align="left">
      <Box>
        <Box
          sx={{
            mb: 2,
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
            <CodeIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'text-bottom' }} />
            Archivo de código:
          </Typography>
          <Paper
            variant="outlined"
            sx={{
              fontFamily: 'monospace',
              p: 1.5,
            }}
          >
            {parsedArgs.targetFile}
          </Paper>
        </Box>

        <Box
          sx={{
            mb: 2,
            display: 'flex',
            gap: 1,
            flexWrap: 'wrap',
          }}
        >
          {parsedArgs.shouldReadEntireFile && <Chip label="Archivo completo" size="small" color="success" />}
          {parsedArgs.startLine && (
            <Chip label={`Línea ${parsedArgs.startLine}`} size="small" color="info" variant="outlined" />
          )}
          {parsedArgs.endLine && (
            <Chip label={`hasta ${parsedArgs.endLine}`} size="small" color="info" variant="outlined" />
          )}
        </Box>
      </Box>
    </MessageWrapper>
  );
};

export default ReadFileToolComponent;
